module.exports = __webpack_public_path__ + "static/three-trends-shaping-the-modern-workplace-4deb27c2cee697eee88971d5564addbb.png";